import { HtmlTag } from "@common/controls/Html";
import Icon, { IconAction } from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import React from "react";

import "./style.less";

type Props = Omit<React.HTMLProps<any>, "ref"> & {
  tag?: string;
  icon?: IconType;
  isDisabled?: boolean;
  tooltip?: string;
};

const DragHandle = ({ isDisabled, icon, tooltip, ...props }: Props) => (
  <HtmlTag className="drag_handle" {...props}>
    <Icon isDisabled={isDisabled} tooltip={tooltip} icon={icon ?? IconType.GripVerticalDots} className="drag-icon" />
  </HtmlTag>
);

export default DragHandle;

export const ActionIconDragHandle = ({ isDisabled, icon, tooltip, ...props }: Props) => (
  <HtmlTag className="drag_handle" {...props}>
    <IconAction
      tooltip={tooltip}
      icon={icon ?? IconType.GripVerticalDots}
      isDisabled={isDisabled}
      className="drag-icon"
      size={20}
    />
  </HtmlTag>
);
